import { Tab } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

export const styles = /* istanbul ignore next */ (theme) => ({
  textColorInherit: {
    opacity: 1,
  },
  root: {
    minWidth: 40,
    maxWidth: 264,
    fontSize: 16,
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  selected: {
    fontWeight: 'bold',
  },
});

export function TabBarItem({
  classes = {},
  icon: Icon = null,
  selected = null,
  title = '',
  ...otherProps
}) {
  const iconElement = Icon ? <Icon /> : null;

  return (
    <Tab
      classes={classes}
      label={title}
      icon={iconElement}
      selected={selected}
      textColor="primary"
      {...otherProps}
    />
  );
}

export default withStyles(styles)(TabBarItem);
